import { changeOwnPassword } from '@urbanik/api-client';
import { Button, FormActions, FormSection, TextField } from '@urbanik/ui';
import { useState, type FormEvent } from 'react';
import { apiBase } from './api-base';
export function MandatoryPasswordChange({ onComplete }: { onComplete: () => void }) {
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  async function submit(e: FormEvent) {
    e.preventDefault();
    setError('');
    if (password !== confirmation) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    setBusy(true);
    try {
      await changeOwnPassword(apiBase, { password, confirmation });
      onComplete();
    } catch (x) {
      setError(x instanceof Error ? x.message : 'No se pudo cambiar la contraseña.');
    } finally {
      setBusy(false);
    }
  }
  return (
    <form onSubmit={(e) => void submit(e)}>
      <FormSection
        title="Crea tu contraseña personal"
        description="La contraseña temporal solo permite este primer acceso. Usa entre 12 y 256 caracteres."
      >
        <TextField
          label="Nueva contraseña"
          type="password"
          autoComplete="new-password"
          required
          minLength={12}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <TextField
          label="Confirmar contraseña"
          type="password"
          autoComplete="new-password"
          required
          minLength={12}
          value={confirmation}
          onChange={(e) => setConfirmation(e.target.value)}
          error={error}
        />
      </FormSection>
      <FormActions>
        <Button type="submit" variant="primary" disabled={busy}>
          {busy ? 'Guardando…' : 'Establecer contraseña y continuar'}
        </Button>
      </FormActions>
    </form>
  );
}
